<template>

    <v-container fluid color="red" class="parent pt-0">

        <counter :hint="hint"
                 :key="statBoxKey"
                 :start-value="startValue"
                 :end-value="endValue"
                 :duration="duration"
                 :loading="loading && !loaded"
                 :digits="5"
                 :trend-angle="trendAngle"
                 class="mb-10"
        ></counter>

    </v-container>
</template>

<script>

    import ToolbarPage from '../../../components/UI/ToolbarPage';
    import {mapState, mapGetters, mapActions} from 'vuex';
    import Counter from "../../../components/UI/Counter";

    export default {

        components: {
            Counter,
            ToolbarPage
        },

        props: {
            name: {
                type: String,
                required: true,
            },
        },
        data() {
            return {
                statBoxKey: 1,
                loaded: false,
                loading: false,
                startValue: null,
                endValue: null,
                trendAngle: 90,
                duration: 1000 * 60 * 60, // 1 hour
                configOptionSelected: null,
                configOptions: [
                    {name: 'Today', value: 'today'},
                    {name: 'Week', value: 'week'},
                    {name: 'Month', value: 'month'},
                    {name: 'Year', value: 'year'}
                ],
                config: null,
            }
        },

        computed: {

            ...mapState('DashBoard', ['widgets']),

            hint() {
                if (this.configOptionSelected) {
                    return 'Completes | ' + this.configOptionSelected.name.toUpperCase();
                }
                return '';
            }
        },

        methods: {

            ...mapActions('DashBoard', ['getStatusPredictions']),

            loadData(force = false) {

                this.loading = true;

                this.$emit('loading-started');

                this.getStatusPredictions({force: force, type: this.configOptionSelected.value})
                    .then(data => {
                        // Destroy old object by incrementing its key
                        // Causes component to fully reset
                        this.statBoxKey++;
                        this.startValue = data.current.completed;
                        this.endValue = data.current.completed + data.predictions.completed;
                        this.angle = data.predictionTrends.completed.angle;
                        this.loaded = true;
                    })
                    .catch(error => {
                        Bus.$emit('flash-message', {type: 'error', message: 'Counter initialization failed!'});
                    })
                    .finally(() => {
                        this.$emit('loading-ended');
                        this.loading = false;
                    });
            },

            emitSettings() {
                this.$emit('settings', {
                    title: this.configOptionSelected.name,
                    info: 'Completed interviews',
                    configs: this.configOptions
                });
                this.$emit('hide-title', true);
            },
        },

        created() {
            // Save config from vuex
            const widget = this.widgets.find(widget => widget.name === this.name);

            if (widget.config) {
                this.configOptionSelected = this.configOptions.find(option => option.value === widget.config);
            } else {
                this.configOptionSelected = this.configOptions[0];
            }
            this.emitSettings();
        },

        mounted() {

            Bus.$on('refresh-widget-' + this.name, () => {
                this.loadData(true);
            });

            Bus.$on('config-widget-' + this.name, (value) => {
                this.configOptionSelected = this.configOptions.find(config => config.value === value);
                this.emitSettings();
                this.loadData(true);
            });

            this.loadData();
        },
    }
</script>

<style scoped>
    .parent {
        display: flex;
        flex-direction: column;
        justify-content: center;
        height: 100%;
    }
</style>
